@if (buttonOnly) {
	@if (restrictFileSourceMenu && allowEditFiles) {
		<button
			(click)="addButtonClick($event, fileInput); $event.stopPropagation()"
			mat-mini-fab
			class="round-button"
		>
			<mat-icon svgIcon="add"></mat-icon>
		</button>
	}

	@if (!restrictFileSourceMenu && allowEditFiles) {
		<button
			(click)="$event.stopPropagation()"
			[matMenuTriggerFor]="entityMenu"
			mat-mini-fab
			class="round-button"
		>
			<mat-icon svgIcon="add"></mat-icon>
		</button>
	}
} @else {
	<au-expansion-panel
		[expanded]="allowEditFiles || filesList().length"
		[panelCanBeExpanded]="filesList().length > 0"
	>
		<ng-container panel-title>
			<div class="files-text-header">
				<span>{{ 'files' | translate }}</span>
				@if (!hideCounter) {
					<div class="files-counter">
						<ongoing-counter [filesList]="filesList()"></ongoing-counter>
					</div>
				}
			</div>
		</ng-container>

		<ng-container panel-description>
			@if (restrictFileSourceMenu && allowEditFiles) {
				<button
					(click)="addButtonClick($event, fileInput); $event.stopPropagation()"
					class="au-add-fab-button surface-fab"
				>
					<mat-icon svgIcon="add"></mat-icon>
				</button>
			}

			@if (!restrictFileSourceMenu && allowEditFiles) {
				<button
					(click)="$event.stopPropagation()"
					[matMenuTriggerFor]="entityMenu"
					mat-mini-fab
					class="surface-fab"
				>
					<mat-icon svgIcon="add"></mat-icon>
				</button>
			}
		</ng-container>

		<ng-container panel-content>
			@if (cardsView && (filesList()?.length || relatedFiles?.length)) {
				<div class="filter-control">
					<au-native-input
						[value]="searchValue"
						placeholder="{{ 'quick_search' | translate }}"
						(inputChanged)="searchHandler($event)"
					/>
				</div>
			}
			@if (allowEditFiles && !filesList().length) {
				<div class="file-loader-wrapper m-t-xs">
					<div
						(dragenter)="onDragFileEnter($event)"
						(dragleave)="onDragFileLeave($event)"
						(dragover)="onDragOver($event)"
						(drop)="handleImageDrop($event)"
						(click)="fileInput.click()"
						[class.dragover]="fileCouldBeDropped"
						class="empty-state-placeholder"
						[matTooltip]="
							'allowed_formats' | translate: { formats: niceFormattedFileTypes }
						"
						[matTooltipDisabled]="showFileTypesHint"
					>
						<mat-icon class="illustration" svgIcon="file-document"></mat-icon>
						<p>{{ 'drag_drop_files' | translate }}</p>

						@if (showFileTypesHint) {
							<p class="text-center">
								{{ 'allowed_formats' | translate: { formats: niceFormattedFileTypes } }}
							</p>
						}
					</div>
				</div>
			}

			@if (filesList().length && !cardsView) {
				<div
					class="list-of-files m-t-xs nice-scroll colored-scroll-track"
					[class.file-list-scroll]="enableFileListScroll"
					(dragenter)="onDragFileEnter($event)"
					(dragover)="onDragOver($event)"
					[class.dragover]="fileCouldBeDropped"
				>
					<div
						class="dragover-layer"
						(drop)="handleImageDrop($event)"
						(dragleave)="onDragFileLeave($event)"
					>
						<mat-icon class="illustration" svgIcon="file-document"></mat-icon>
						<p>{{ 'drag_drop_files' | translate }}</p>
					</div>
					@for (fileData of filesList(); track fileData.id) {
						<div>
							<!--
					In case if component used in cmms file data have pk and id
					while case if it used in digital tween it have id only.
					Currently we have no logic to delete file from digital tween
					so we need to hide delete button in this case.
					At the same time if cmms has no pk it means that file should not have delete button as well.
					 -->
							<au-files-list-item
								[fileTypesConfig]="fileTypesConfig"
								[fileData]="fileData"
								[showDeleteButton]="!!fileData?.pk"
								[showCancelButton]="
									fileData.loadingProgress !== 100 || !(fileData?.pk || fileData?.id)
								"
								[disableBulkSelections]="disableBulkSelections"
								(retryToLoadFile)="retryLoadFile($index)"
								(openFile)="openFile($index)"
								(deletePressed)="deleteItemFromFileList($index)"
								(cancelPressed)="removeItemFromFileList($index)"
							></au-files-list-item>
						</div>
					}
				</div>
			}

			@if (cardsView) {
				<div class="file-cards-list m-t-xs">
					@if (filteredFileList.length) {
						<div
							class="list-of-files"
							[class.file-list-scroll]="enableFileListScroll"
							(dragenter)="onDragFileEnter($event)"
							(dragover)="onDragOver($event)"
							[class.dragover]="fileCouldBeDropped"
						>
							<file-cards-list
								[selection]="selection"
								[title]="uploadTitle"
								[filesData]="filteredFileList"
								(openFile)="openFile($event)"
								(deleteFile)="deleteItemFromFileList($event)"
							/>

							<div
								class="dragover-layer"
								(drop)="handleImageDrop($event)"
								(dragleave)="onDragFileLeave($event)"
							>
								<mat-icon class="illustration" svgIcon="file-document"></mat-icon>
								<p>{{ 'drag_drop_files' | translate }}</p>
							</div>
						</div>
					}

					@if (filteredRelatedFiles?.length) {
						<file-cards-list
							[selection]="selection"
							[filesData]="filteredRelatedFiles"
							[allowDelete]="false"
							[title]="'Related'"
							(openFile)="openRelatedFile($event)"
							(deleteFile)="deleteItemFromFileList($event)"
						/>
					}

					@if (selection.selected.length) {
						<div class="toolbar-wrapper">
							<files-toolbar
								class="toolbar"
								[useSelectionService]="false"
								[selections]="selection.selected.length"
								[delegateClear]="true"
								[relatedFilesSelected]="relatedFileSelected"
								(deletePressed)="deleteMultipleItemsFromFileList()"
								(clearPressed)="clearSelectionPressed()"
							></files-toolbar>
						</div>
					}
				</div>
			}

			@if ((selections$ | async).length) {
				<files-toolbar
					(deletePressed)="deleteMultipleItemsFromFileList()"
				></files-toolbar>
			}
		</ng-container>
	</au-expansion-panel>
}

<!-- $event.target['value']=null
				 we need to nulled value inside the input to allow
				 loading of the same file more then 1 time -->
<input
	#fileInput
	type="file"
	[accept]="fileTypesConfigToFileTypes()"
	[multiple]="!options?.restrictMultipleFilesLoading"
	(click)="$event.target['value'] = null"
	(change)="onFileChanged($event)"
	hidden
/>

<mat-menu
	#entityMenu="matMenu"
	class="au-select-actions"
	[xPosition]="'after'"
	[yPosition]="'below'"
>
	<button mat-menu-item (click)="addExisting(); $event.stopPropagation()">
		<mat-icon svgIcon="files"></mat-icon>
		<span>{{ 'existing_file' | translate }}</span>
	</button>

	<button mat-menu-item (click)="addButtonClick($event, fileInput)">
		<mat-icon svgIcon="add"></mat-icon>
		<span>{{ 'new_file' | translate }}</span>
	</button>
</mat-menu>
